
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EducationCourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"guid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseGuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"language_id"},"value":{"kind":"StringValue","value":"ita","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course_guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner_guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_lessons"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_students_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_students_max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_room"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_availability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_subjectarea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_info_more"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teachers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lessons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lesson_guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderby"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"start_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teacher_guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesson_url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course_student_status"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":795}};
    doc.loc.source = {"body":"query($courseGuid: String) {\n  EducationCourse(guid: $courseGuid, language_id: \"ita\") {\n    course_guid\n    owner_guid\n    course_title\n    course_lessons\n    course_students_min\n    course_students_max\n    course_type\n    course_room\n    course_address\n    course_location\n    course_hours\n    course_availability\n    course_link\n    course_status\n    course_subjectarea\n    course_info\n    course_info_more\n    teachers {\n      guid\n      name\n      surname\n      email\n    }\n    lessons {\n      lesson_guid\n      course_guid\n      orderby\n      lesson_title\n      lesson_info\n      lesson_date\n      lesson_from\n      lesson_to\n      start_url\n      teacher_guid\n      join_url\n      lesson_url\n    }\n    students {\n      guid\n      name\n      surname\n      course_student_status\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
